import { useExtensionData } from '../../hooks/extensionStorageListener'
import { STORAGE_KEY } from '../../utils/enums'

export async function setWelcomed(welcomed: boolean): Promise<void> {
  return chrome.storage.local.set({
    [STORAGE_KEY.USER_WELCOMED]: welcomed,
  })
}

export function useWelcomed(): boolean | undefined {
  const { data, isLoaded } = useExtensionData({
    local: [STORAGE_KEY.USER_WELCOMED],
  })

  if (!isLoaded || !data) {
    // Still loading
    return undefined
  }

  return data[STORAGE_KEY.USER_WELCOMED] || false
}
